exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.schedule-select[data-v-6c862ae7] {\n  gap: 10px;\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/prod/mcFrontend2/src/components/common/tabs/tabs_transfer_schedule/tab_daily.vue"],"names":[],"mappings":";AAAA;EACE,UAAU;CACX","file":"tab_daily.vue","sourcesContent":[".schedule-select {\n  gap: 10px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c862ae7","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tabs/tabs_transfer_schedule/tab_daily.vue
// module id = 0LNS
// module chunks = 1